<template>
  <div id="app">
    <video muted autoplay class="upload-video" id="uploadVideo"></video>
    <router-view />
    <add-ins-user ref="addInsUser" v-model="showAddInsUser"></add-ins-user>
    <schedule-form
      v-if="showAddScheduleForm"
      :info="addScheduleFormInfo"
      ref="postForm"
    ></schedule-form>
    <download-modal
      :msg="downloadMsg"
      v-model="showDownloadModal"
    ></download-modal>
    <repost-detail
      @close="showRepostDetailDialog = false"
      v-show="showRepostDetailDialog"
      ref="repostDetail"
    ></repost-detail>
    <facebook-group-modal
      ref="facebookGroup"
      @close="showFacebookGroupModal = false"
      v-show="showFacebookGroupModal"
    ></facebook-group-modal>
    <!-- 发送失败的提示信息 -->
    <el-dialog
      title="Not Auto Post"
      :visible.sync="notAutoPostModal"
      width="700px"
    >
      <div>
        <div>According to Instagram auto post limitation made by Facebook:</div>
        <div>
          IG Business accounts can only auto post single photo or video to
          Instagram feed, and it is limited to 25 posts within 24 hours.
        </div>
        <div>Story and Multi-image cannot auto post.</div>
        <div>
          We will send you a notification when it's time to post. You can post
          this schedule manually.
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="alreadyClick"
          >Already changed to IG Business?</el-button
        >
        <el-button type="primary" @click="changeClick"
          >How to change to IG Business?</el-button
        >
        <el-button type="primary" @click="notAutoPostModal = false"
          >OK</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateUserInfo } from "./service/user";
import { list as planList } from "./service/plans";
import { showErrorMsg } from "./utils/errors";
import {
  CURRENT_USER_INFO,
  LANGUAGE,
  CURRENT_PUBLISHER_ID,
  CURRENT_PUBLISHER_SIMPLE,
} from "./store/mutation-types";
import moment from "moment-timezone";
import addInsUser from "./components/plan_header/add_ins_user/Index";
import scheduleForm from "./components/media/schedule/form/Form";
import DownloadModal from "./components/common/Download";
import RepostDetail from "./components/repost/Detail";
import FacebookGroupModal from "./components/login/FacebookGroup";
import { postAll } from "./api/post";
import {
  validateCurrentPublisherStatus,
  setCurrentPublisherCommentCaption,
  publishipsFacebook,
  requestToken,
  accessToken,
  publishipsTwitter,
} from "./service/publisher";
import { mapGetters } from "vuex";
import { getDevice, getQueryString } from "./utils/index";
// eslint-disable-next-line
// import Twitter from './utils/twitter'
export default {
  name: "App",
  components: {
    DownloadModal,
    addInsUser,
    scheduleForm,
    RepostDetail,
    FacebookGroupModal,
  },
  computed: {
    ...mapGetters({
      publisherId: CURRENT_PUBLISHER_ID,
      publisher: CURRENT_PUBLISHER_SIMPLE,
    }),
  },
  data() {
    return {
      showAddInsUser: false,
      showAddScheduleForm: false,
      showDownloadModal: false,
      downloadMsg:
        "We will support this feature on Apphi DESKTOP soon. You can use Apphi APP for this feature now.",
      showRepostDetailDialog: false,
      addScheduleFormInfo: {},
      showFacebookGroupModal: false,
      facebookGroupInfo: {},
      notAutoPostModal: false, // 发送失败提示
    };
  },
  methods: {
    alreadyClick() {
      window.open(
        "https://faq.apphi.com/en/articles/4870095-already-changed-to-ig-business-account-but-still-in-manual-mode",
        "_blank"
      );
      this.notAutoPostModal = false;
    },
    changeClick() {
      window.open(
        "https://faq.apphi.com/en/articles/4870095-already-changed-to-ig-business-account-but-still-in-manual-mode",
        "_blank"
      );
      this.notAutoPostModal = false;
    },
  },
  async created() {
    const _this = this;
    const oauth_token = getQueryString("oauth_token");
    const oauth_verifier = getQueryString("oauth_verifier");
    // 判断2个是否存在字段，存在说明是twitter登录
    if (oauth_token && oauth_verifier) {
      const loading = this.$loading();
      try {
        // 尝试绑定
        var state = { title: "", url: window.location.href };
        history.pushState(state, "", "/#/layout/schedule");
        const { access_token, access_token_secret } = await accessToken({
          oauthVerifier: oauth_verifier,
        });
        const publisher = await publishipsTwitter({
          access_token,
          access_token_secret,
        });
        _this.$bus.$emit("closeEmpytModal");
        _this.$store.commit(CURRENT_PUBLISHER_ID, publisher.publisher.id);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    }
    // 添加全局监听，打开schedule表单
    this.$bus.$on("closeAll", (data) => {
      this.showAddScheduleForm = false;
      this.showRepostDetailDialog = false;
      this.showDownloadModal = false;
    });
    // 添加全局监听，打开schedule表单
    this.$bus.$on("showScheduleForm", (data) => {
      // ig tv无脑弹下载
      if (data.mediaType === 22) {
        this.$bus.$emit("showDownload");
        return;
      }
      // 判断当前用户是否为非ins 非ins用户不能选择视频图片混合
      if (
        this.publisher.socialNetwork !== 1 &&
        data.mediaType > 1 &&
        data.images.find((i) => i.type === 2)
      ) {
        this.$bus.$emit("showDownload");
        return;
      }
      this.addScheduleFormInfo = data;
      this.showAddScheduleForm = true;
    });
    this.$bus.$on("closeScheduleForm", () => {
      this.showAddScheduleForm = false;
    });
    this.$bus.$on(
      "showAddIns",
      ({ publisherId, homeLogin = false, callback }) => {
        // eslint-disable-next-line
        FB.login(
          async (response) => {
            const loading = this.$loading();
            try {
              await publishipsFacebook({
                social_user_token: response.authResponse.accessToken,
                publisherId,
                homeLogin,
                social_network: 1,
              });
              if (callback) {
                callback();
              }
            } catch (e) {
              showErrorMsg(e);
            } finally {
              loading.close();
            }
          },
          {
            scope:
              "pages_show_list,pages_read_engagement,instagram_basic,instagram_content_publish,instagram_manage_comments",
          }
        );
      }
    );
    // 添加全局弹出fb page登录框
    this.$bus.$on(
      "showAddFacebookPage",
      ({ publisherId, homeLogin = false, callback }) => {
        // eslint-disable-next-line
        FB.login(
          async (response) => {
            console.log("FB从未登录尝试登录", response);
            const loading = this.$loading();
            try {
              await publishipsFacebook({
                social_user_token: response.authResponse.accessToken,
                publisherId,
                homeLogin,
              });
              if (callback) {
                callback();
              }
            } catch (e) {
              showErrorMsg(e);
            } finally {
              loading.close();
            }
            // handle the response
          },
          { scope: "manage_pages,publish_pages" }
        );
      }
    );
    // 添加全局弹出fb group登录框
    this.$bus.$on("showAddFacebookGroup", ({ publisherId, callback }) => {
      /* eslint-disable no-undef */
      FB.login(
        async (response) => {
          console.log("FB从未登录尝试登录", response);
          const loading = this.$loading();
          FB.api(`${response.authResponse.userID}/groups`, function (group) {
            if (!response || response.error) {
              loading.close();
            } else {
              let count = 0;
              group.data.forEach((groupItem) => {
                FB.api(
                  `/${groupItem.id}/picture`,
                  "GET",
                  { redirect: 0, type: "large" },
                  function (image) {
                    if (!image || image.error) {
                      loading.close();
                    }
                    count += 1;
                    groupItem.url = image.data.url;
                    // 如果全部轮询一遍则弹框
                    if (count === group.data.length) {
                      _this.showFacebookGroupModal = true;
                      _this.$refs.facebookGroup.setGroup({
                        group: group.data,
                        token: response.authResponse.accessToken,
                        callback,
                      });
                      loading.close();
                    }
                  }
                );
              });
            }
          });
          loading.close();
          // handle the response
        },
        { scope: "publish_to_groups" }
      );
    });
    this.$bus.$on("showAddTwitter", async () => {
      const loading = this.$loading();
      try {
        const callbackUrl = `https://${window.location.hostname}/#/layout/schedule`;
        const { auth_url } = await requestToken({ callbackUrl: callbackUrl });
        window.location.href = auth_url;
      } catch (e) {
        showErrorMsg(e);
        loading.close();
      }
    });
    // 添加全局下载框
    this.$bus.$on("showDownload", (data) => {
      this.showDownloadModal = true;
      if (data) {
        this.downloadMsg = data.msg;
      } else {
        this.downloadMsg =
          "We will support this feature on Apphi DESKTOP soon. You can use Apphi APP for this feature now.";
      }
    });
    this.$bus.$on("showRepostDetail", (data) => {
      // 验证当前用户是否需要登录，如果需要登录则弹出提示
      if (!validateCurrentPublisherStatus()) {
        return;
      }
      this.showRepostDetailDialog = true;
      this.$nextTick(() => {
        this.$refs.repostDetail.show({ detail: data });
      });
    });
    // 全局发送失败点击提示
    this.$bus.$on("showPostErrorMessage", async (data) => {
      const { item } = data;
      console.log("item", this.publisher.socialNetwork);
      if (item.state !== "post-not-auto") {
        return;
      }
      const black =
        this.publisher.socialNetwork === 1 &&
        (item.mediaType === 3 ||
          item.mediaType === 8 ||
          item.mediaType === 22 ||
          !this.publisher.isBusiness);
      if (!black) {
        // 没有 autopost 也没有 unlimited
        if (
          !this.publisher.isUnlimited &&
          this.publisher.autopostRemaining <= 0
        ) {
          await this.$confirm.show({
            title: "Upgrade To Auto Post",
            text: `This schedule is qualified for schedules. But @${this.publisher.username} used 10/10 free schedules this month. Please upgrade your plan to get unlimited schedules.`,
            yesText: "Upgrade",
            cancelText: "Cancel",
          });
        }
        if (this.publisher.isUnlimited) {
          await this.$confirm.show({
            title: "",
            text: `Auto Post?`,
            yesText: "Yes",
            cancelText: "Cancel",
          });
          // loading
          const loading = this.$loading();
          try {
            await postAll();
          } catch (e) {
            showErrorMsg(e);
          } finally {
            loading.close();
          }
        }
      } else {
        this.notAutoPostModal = true;
      }
    });
    try {
      // 页面加载之时判断设备所选语言
      let language = this.$store.getters[LANGUAGE];
      language = "en";
      // 然后切换语言
      this.$i18n.set(language);
      moment.locale("en");
      // 强制判断当前用户是否用mobile打开，如果用mobile则强制打开mobile页面
      if (getDevice() !== "web") {
        this.$router.replace({ name: "MobilePage" });
        return;
      }
      // 当前登录人信息为空说明是登出状态则无论跳转到什么页面都强制跳转登录页
      if (
        !this.$store.getters[CURRENT_USER_INFO] &&
        this.$route.name !== "ValidateHomePage" &&
        this.$route.name !== "ValidateDownloadPage"
      ) {
        this.$router.push({ name: "LoginPage" });
      } else {
        // 在登录页则不获取用户信息 验证用户是否verify的操作
        if (
          this.$route.name !== "LoginPage" &&
          this.$route.name !== "ValidateHomePage" &&
          this.$route.name !== "ValidateDownloadPage"
        ) {
          await updateUserInfo({});
          validateCurrentPublisherStatus();
        }
      }
      await planList();
    } catch (e) {
      showErrorMsg(e);
    }
  },
  watch: {
    publisherId: {
      async handler(val) {
        // 登录页不更新comment caption信息
        if (this.$route.name !== "LoginPage") {
          await setCurrentPublisherCommentCaption({ publisherId: val });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less">
@import "./assets/style/theme";
@import "./assets/style/element";
.upload-video {
  position: fixed;
  top: 500px;
  left: 0;
  height: 1px;
  width: 1px;
}
div {
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
}

input:read-only {
  cursor: not-allowed;
}
input,
textarea {
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}
body {
  padding: 0;
  margin: 0;
  overflow-y: hidden;
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  outline: none;
  @icon-size: 15px;
  .ins-user-icon,
  .fb-page-user-icon,
  .fb-group-user-icon,
  .tw-user-icon {
    width: @icon-size;
    height: @icon-size;
    background-size: contain !important;
    position: absolute;
    right: -1px;
    bottom: -1px;
  }
  .fb-page-user-icon {
    background: url("../public/images/common/fb_small@3x.png");
  }
  .fb-group-user-icon {
    background: url("../public/images/common/fb_group_small@3x.png");
  }
  .tw-user-icon {
    background: url("../public/images/common/tw_small@3x.png");
  }
  .ins-user-icon {
    background: url("../public/images/common/ins_small@3x.png");
  }
}

.drag,
img {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently                             supported by Chrome and Opera */
}
</style>
